<template>
  <main-layout>
    <v-container fluid>
      <div class="mb-2">
        <date-filter
          @changeDate="onChangeDate"
          :defaultFilter="'last_7_days'"
          v-model="selectedDate"
        ></date-filter>
      </div>
      <div class="mb-2">
        <div class="text-xs-right">
          <exportxlsx :promisedValue="getXlsxData"></exportxlsx>
        </div>
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 sm9>
            <div>
              <v-pagination
                :total-visible="6"
                v-model="pageNumber"
                @input="changePage"
                :length="pagelength"
              ></v-pagination>
            </div>
          </v-flex>
          <v-flex xs12 sm3 class="text-xs-right">
            <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>ค้นหา</v-btn>
          </v-flex>
        </v-layout>
      </div>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        hide-actions
        :pagination.sync="pagination"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <!-- :style="{ backgroundColor: props.item.member_status == 'true' ? '#e6ffe6' : 'white' }" -->
          <tr>
            <td>{{ props.item.userdata.firstName }} {{ props.item.userdata.lastName }}</td>
            <td>
              <div>
                <span>{{ props.item.userdata.phone }}</span>
                <v-btn @click="onEditPhone(props.item)" icon>
                  <v-icon>edit</v-icon>
                </v-btn>
              </div>
            </td>
            <td>{{ formatdate(props.item.userdata.timestamp) }}</td>
            <td>{{ props.item.alltime_score ? props.item.alltime_score : 0 }}</td>
            <td>{{ props.item.used_score ? props.item.used_score : 0 }}</td>
            <td>
              {{ calCurrScore(props.item.alltime_score, props.item.used_score) }}
            </td>
            <td class="text-xs-right">
              <v-btn
                @click="onShowHistoryCoupon(props.item.userid)"
                color="primary"
                style="font-size: 13px"
              >
                <span>ประวัติการแลกของรางวัล</span>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div>
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>
      <v-dialog v-model="showsearch" width="500px" persistent>
        <v-card>
          <div style="float: right">
            <v-btn @click="showsearch = false" icon><v-icon>close</v-icon></v-btn>
          </div>
          <div class="pa-2 pt-4 pb-3">
            <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
            <div>
              <v-layout class="pa-0 ma-0" wrap row>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('ชื่อ') }}</label>
                  <input v-model="filter.name" class="form-control" type="text" />
                </v-flex>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('เบอร์โทรศัพท์') }}</label>
                  <input v-model="filter.phoneNumber" class="form-control" type="text" />
                </v-flex>
                <v-flex xs12 sm6 class="form-control pa-1">
                  <label>{{ $t('วันที่สมัคร - start') }}</label>
                  <DatePickerWithoutButton v-model="filter.dateFrom">
                    <input
                      readonly
                      :value="formatdate(filter.dateFrom)"
                      class="form-control"
                      type="text"
                    />
                  </DatePickerWithoutButton>
                </v-flex>
                <v-flex xs12 sm6 class="form-control pa-1">
                  <label>{{ $t('วันที่สมัคร - end') }}</label>
                  <DatePickerWithoutButton v-model="filter.dateTo">
                    <input
                      readonly
                      :value="formatdate(filter.dateTo)"
                      class="form-control"
                      type="text"
                    />
                  </DatePickerWithoutButton>
                </v-flex>
              </v-layout>
            </div>
            <div class="text-xs-center">
              <v-btn @click="clearsearch" outline color="grey">Clear</v-btn>
              <v-btn @click="onsearch" color="primary">Search</v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showImageDialog" width="550px">
        <div>
          <v-img
            @click="showImageDialog = false"
            v-if="showImageDialog"
            :src="currentShowImage"
          ></v-img>
        </div>
      </v-dialog>
      <v-dialog persistent width="950px" v-model="editModal">
        <v-card v-if="editModal">
          <MemberEdit
            @onsave="oneditmember"
            @close="editModal = false"
            :editdata="editdata"
          ></MemberEdit>
        </v-card>
      </v-dialog>
      <v-dialog persistent width="300px" v-model="editPhone">
        <v-card v-if="editPhone">
          <div class="pa-2">
            <div class="text-xs-right pb-2">
              <v-btn @click="editPhone = false" icon outline>
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <div class="text-xs-left form-control">
              <span>Phone: </span>
              <input
                name="phone"
                v-model="editDataPhone.phone"
                type="text"
                class="form-control"
                outline
              />
            </div>
            <div class="text-xs-center pt-2">
              <v-btn @click="onSavePhone" :loading="loadingSavePhone" color="primary">
                <span>ตกลง</span>
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog persistent width="950px" v-model="historyCouponModal">
        <v-card v-if="historyCouponModal">
          <MemberHistoryCoupon :id="userid" @close="closeHistoryModal"> </MemberHistoryCoupon>
        </v-card>
      </v-dialog>
    </v-container>
  </main-layout>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import MemberEdit from './MemberEdit.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import api from '@/api'
import SearchMember from './SearchMember.vue'
import { mapGetters } from 'vuex'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import MemberHistoryCoupon from './MemberHistoryCoupon.vue'

export default {
  components: {
    Multiselect,
    SearchMember,
    DatePickerWithoutButton,
    MemberEdit,
    exportxlsx,
    DateFilter,
    MemberHistoryCoupon
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: 'name' },
      editModal: false,
      branchOptions: '',
      editdata: '',
      showImageDialog: false,
      currentShowImage: '',
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      showsearch: false,
      filter: {
        name: '',
        phoneNumber: '',
        dateFrom: '',
        dateTo: ''
      },
      loading: false,

      items: [],
      headers: [
        { text: 'ชื่อ-นามสกุล', value: 'name' },
        { text: 'เบอร์โทรศัพท์', value: 'phone_number' },
        { text: 'วันที่สมัคร', value: 'register_date' },
        { text: 'แต้มที่หมด', value: 'allscore' },
        { text: 'แต้มที่แลกทั้งหมด', value: 'used_score' },
        { text: 'แต้มคงเหลือ', value: 'score' },
        { text: '', value: '' }
      ],
      memberStatus: null,
      editPhone: false,
      editDataPhone: {
        userid: '',
        phone: ''
      },
      userid: '',
      historyCouponModal: false,
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      isExport: false,
      lastGetData: '',
      loadingSavePhone: false
    }
  },
  mounted() {
    this.getData(false, false)
  },
  methods: {
    getXlsxData() {
      let vm = this
      return new Promise(async (resolve) => {
        this.isExport = true
        var data = await this.getData(true, false)

        resolve(
          data.map((el) => {
            // if(el.member_status == "true") {
            //   this.memberStatus = "อนุมัติแล้ว";
            // } else {
            //   this.memberStatus = 'None';
            // }

            return {
              ชื่อลูกค้า: el.userdata.firstName + ' ' + el.userdata.lastName,
              เบอร์โทร: el.userdata.phone,
              วันที่สมัครสมาชิก: el.userdata.timestamp
                ? moment(el.userdata.timestamp).format('DD/MM/YYYY HH:mm')
                : '',
              แต้มที่หมด: el.alltime_score ? el.alltime_score : 0,
              แต้มที่แลกทั้งหมด: el.used_score ? el.used_score : 0,
              แต้มคงเหลือ: vm.calCurrScore(el.alltime_score, el.used_score)
            }
          })
        )
      })
    },
    calCurrScore(data1, data2) {
      let val1 = parseFloat(data1)
      let val2 = parseFloat(data2)
      if (val1 && !data2) {
        return val1
      } else if (val1 && val2) {
        let out = val1 - val2
        return out > 0 ? out : 0
      } else {
        return 0
      }
    },
    oneditmember() {
      this.editModal = false
      this.getData()
    },
    showEdit(item) {
      this.editdata = item
      this.editModal = true
    },
    onChangeDate() {
      this.filter = {
        name: '',
        identityNumber: '',
        phoneNumber: '',
        dateFrom: '',
        dateTo: ''
      }
      this.getData(false, false, 'date')
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData(false, true)
      }
    },
    onsearch() {
      this.getData(false, false, 'search')
      this.showsearch = false
    },
    clearsearch() {
      this.filter = {
        name: '',
        identityNumber: '',
        phoneNumber: '',
        dateFrom: '',
        dateTo: ''
      }
      this.onsearch()
    },
    onEditPhone(item) {
      this.editPhone = true
      this.editDataPhone.userid = item.userid
      this.editDataPhone.phone = item.userdata.phone
    },
    onSavePhone() {
      this.loadingSavePhone = true
      let data = {
        pageid: this.selectedBot.pageid,
        userid: this.editDataPhone.userid,
        phone: this.editDataPhone.phone
      }
      api.updateMemberPhoneToaecoupon(data, (err, response) => {
        this.loadingSavePhone = false
        if (response.responsecode == 200) {
          this.editPhone = false
          this.$swal.fire({ text: 'อัพเดทเบอร์โทรศัพท์เรียบร้อย' })
          this.getData(false, false)
        } else {
          this.$swal.fire({ text: 'อัพเดทเบอร์โทรศัพท์ไม่สำเร็จ' })
        }
      })
    },
    formatdate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else return ''
    },
    getData(getall = false, isFirst = false, condition = 'date') {
      return new Promise((resolve) => {
        if (!isFirst) {
          this.offset = 0
          this.pagetmp = 1
          this.pageNumber = 1
        }

        if (this.filter.dateFrom || this.filter.dateTo) {
          condtion = 'search'
        } else {
          condition = 'date'
        }

        var data = {
          pageid: this.selectedBot.pageid,
          name: this.filter.name, // filter ชื่อ
          phone: this.filter.phoneNumber, // filter เบอร์
          start_date: condition == 'date' ? this.selectedDate.start : this.filter.dateFrom, // YYYY-MM-DD
          end_date: condition == 'date' ? this.selectedDate.end : this.filter.dateTo // YYYY-MM-DD
        }
        if (!getall) {
          Object.assign(data, {
            limit: this.limit,
            offset: this.offset
          })
        }

        if (this.isExport) {
          Object.assign(data, {
            limit: this.total,
            offset: this.offset
          })
        }

        this.loading = true
        api.getMembersToaecoupon(data, (err, response) => {
          this.loading = false
          if (response.responsecode == 200) {
            if (!getall) {
              this.items = response.data
            }

            this.total = response.total
            resolve(response.data)
          }
        })
      })
    },
    onShowHistoryCoupon(userid) {
      this.userid = userid
      this.historyCouponModal = true
    },
    closeHistoryModal() {
      this.historyCouponModal = false
    }
  }
}
</script>

<style lang="scss">
@import 'photoviewer/dist/photoviewer.css';
</style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/Member.vue